import {Module} from "../../models/Module";
import {ModuleCollection} from "../../collections/Modules";
import * as _ from "lodash";
import * as $ from "jquery";
import {ActionPacketCollection} from "../../collections/ActionPackets";
import {PermissionCollection} from "../../collections/Permissions";
import {GenericDeleteModal} from "../modals/GenericDeleteModal";
import {SensorConfigCollection} from "../../collections/SensorConfigs";
import {StatusView} from "./StatusView";
import {BaseInternalView, BaseInternalViewOptions} from "../_BaseViews";
import {SensorStatus} from "../../common/SensorStatus"

var template = require('templates/status/sidePanel.html');
require('backbone');

interface SidePanelViewOptions extends BaseInternalViewOptions {
    parentView: StatusView;
    currentInstallId: number;
    currentOrgId: number;
    permissionCollection: PermissionCollection;
    sensorConfigCollection: SensorConfigCollection;
}

export class SidePanelView extends BaseInternalView {

    options: SidePanelViewOptions;
    model: Module;
    sensorsExpanded: number[] = [];
    channelsChecked = {};
    currentFilter: string[] = [];

    moduleCollection: ModuleCollection;
    actionPacketCollection: ActionPacketCollection;

    template = _.template(template);

    constructor(options: SidePanelViewOptions) {
        super(_.extend(options, {
            el: '#status-sidepanel-container',
            events: {
                'click .status-internal-reading-column': 'chartInternalSensor',
                'click .chart-status-error-codes': 'chartErrorCodes',
                'click .reset-button': 'handleReset',
                'click .create-ap': 'handleCreateActionPacket',

                'click .js-status-sensor-delete': 'handleDeleteSensor',
                'click .js-status-module-delete': 'handleDeleteModule',

                'click .status-channel-selector-expandable': 'expandSensor',
                'click .status-channel-selector-row': 'toggleChannel',
                'input .status-channel-selector-filter': 'updateFilter'
            }
        }));

        this.listenTo(this.moduleCollection, 'sync', this.render.bind(this));
        this.listenTo(this.moduleCollection, 'reset', this.render.bind(this));
        this.listenTo(this.moduleCollection, 'change', this.render.bind(this));

        if (this.options.permissionCollection.canModifyInstallOverrides(this.options.currentInstallId)) {
            this.actionPacketCollection = new ActionPacketCollection([], {installId: this.options.currentInstallId});
            this.listenTo(this.actionPacketCollection, 'sync', this.render.bind(this));
            this.actionPacketCollection.fetch({reset: true});
        }

        this.setModel(this.model);
    }

    handleDeleteSensor(e: JQuery.UIEventBase) {
        var parentView = this.options.parentView;
        var sensorId = $(e.currentTarget).attr('data-sensor-id');
        var sensorName = $(e.currentTarget).attr('data-sensor-name');

        var modal = new GenericDeleteModal({
            type: 'Sensor',
            name: sensorName,
            buttonText: 'Delete Sensor and Data',
            func: () => {
                parentView.stopListening();
                parentView.collectionLoaded = false;
                parentView.render();

                return $.ajax({
                    type: "DELETE",
                    url: window.location.origin + '/api/v1/sensor/' + sensorId,
                    complete: () => {
                        parentView.resetView();
                    }
                });
            },
            warning: "Warning:  Deleting this sensor will permanently erase all of its associated data."
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    handleDeleteModule(e: JQuery.UIEventBase) {
        var parentView = this.options.parentView;
        var moduleId = $(e.currentTarget).attr('data-module-id');
        var moduleName = $(e.currentTarget).attr('data-module-name');

        var modal = new GenericDeleteModal({
            type: 'Module',
            name: moduleName,
            buttonText: 'Delete Module and Data',
            func: () => {
                parentView.stopListening();
                parentView.stopUpdating();
                parentView.collectionLoaded = false;

                return $.ajax({
                    type: "DELETE",
                    url: window.location.origin + '/api/v1/installs/' + this.options.currentInstallId + '/modules/' + moduleId,
                    complete: () => {
                        // If the hash does not contain a module id the following line will not refresh the view
                        // However, if it does contain a module Id we need to remove the id from the hash
                        window.location.hash = '#/status/' + this.options.currentOrgId + '/' + this.options.currentInstallId;

                        window['App'].Bus.trigger('switch:install', this.options.currentInstallId, null);
                        setTimeout(() => {this.options.parentView.resetView()});
                    }
                });
            },
            warning: "Warning:  Deleting this module will permanently erase all of its associated data. We strongly " +
                "recommend you do the following before you delete a module: "
        });
        $('.modals').append(modal.render().el);
        modal.show();
        modal.$('.text-danger').append("<ul>" +
            "<li>Unplug/Remove Power from the module</li>" +
            "<li>Download all data from the module (via dashboard exports or FTP)</li>" +
            "<li>Record any module settings you may need (configuration, channel names, etc)</li>" +
            "</ul>" +
            "</br> Please contact Attune if you have any questions")
    }

    collapseAllSensors() {
        this.sensorsExpanded = [];
        this.render();
    }

    updateFilter(e: JQuery.UIEventBase) {
        var row = $(e.currentTarget);
        var val = (<string> $(row).val());
        var connector = Number(row.attr('data-sensor-connector'));
        var sensorId = Number(row.attr('data-sensor-id'));

        this.currentFilter[connector] = val;
        _.each(this.$(".status-unselected-" + sensorId + ' .status-channel-selector-row'), (r) => {
            if ($(r).attr('data-channel-name').toLowerCase().indexOf(val.toLowerCase()) === -1) {
                $(r).addClass('hidden');
            } else {
                $(r).removeClass('hidden');
            }
        });
    }

    insertChannelAlphabetically(klass, element: JQuery) {
        var elementName = $(element).attr('data-channel-name');

        var rows = this.$(klass + ' .status-channel-selector-row');
        for (var i = 0; i < rows.length; i++) {
            var name = $(rows[i]).attr('data-channel-name');
            if (name > elementName) {
                $(rows[i]).before(element);
                return;
            }
        }

        if (rows.length === 0) {
            this.$(klass).append(element);
        } else {
            $(rows[i - 1]).after(element);
        }
    }

    toggleChannel(e: JQuery.UIEventBase) {
        var row = $(e.currentTarget);
        var sensorId = Number(row.attr('data-sensor-id'));
        var channelId = Number(row.attr('data-channel-id'));
        var connector = Number(row.attr('data-sensor-connector'));
        var oldState = Number(row.attr('data-selected'));

        row.remove();
        if (oldState == 1) {
            this.channelsChecked[sensorId] = _.without(this.channelsChecked[sensorId], channelId);
            row.attr('data-selected', 0).removeClass('bg-info').removeClass('text-info');
            row.find('.fa').removeClass('fa-minus-square').addClass('fa-plus-square');
            this.insertChannelAlphabetically('.status-unselected-' + sensorId, row);

        } else {
            if (!_.has(this.channelsChecked, sensorId)) this.channelsChecked[sensorId] = [];
            this.channelsChecked[sensorId].push(channelId);
            row.attr('data-selected', 1).addClass('bg-info').addClass('text-info');
            row.find('.fa').addClass('fa-minus-square').removeClass('fa-plus-square');
            this.insertChannelAlphabetically('.status-selected-' + sensorId, row);
        }

        if (this.channelsChecked[sensorId].length) {
            this.options.parentView.showChart(connector, this.channelsChecked[sensorId]);
        } else {
            this.options.parentView.hideChart();
        }
    }

    expandSensor(e: JQuery.UIEventBase) {
        var sensorId = Number($(e.currentTarget).attr('data-sensor-id'));
        var connector = Number($(e.currentTarget).attr('data-sensor-connector'));

        this.sensorsExpanded = [sensorId];

        if (this.channelsChecked[sensorId] && this.channelsChecked[sensorId].length) {
            this.options.parentView.showChart(connector, this.channelsChecked[sensorId]);
        }
        this.render();
    }

    chartInternalSensor(e: JQuery.UIEventBase) {
        this.collapseAllSensors();
        var idStrings = $(e.currentTarget).attr('data-channel-id');
        if(!idStrings) return;

        var ids = _.map(idStrings.split(','), Number);
        this.options.parentView.showChart(0, ids);
    }

    chartErrorCodes(e: JQuery.UIEventBase) {
        this.collapseAllSensors();
        var errorT_id = Number($(e.currentTarget).attr('data-errorT-id'));
        var errorP_id = Number($(e.currentTarget).attr('data-errorP-id'));
        var errorV_id = Number($(e.currentTarget).attr('data-errorV-id'));
        //If there are no channels for a sensor's TPV these may all be zeroes
        this.options.parentView.showChart(0, [errorT_id, errorP_id, errorV_id]);
    }

    setModel(model) {
        this.model = model;
        if (this.model) {
            this.channelsChecked = {};
            this.collapseAllSensors();
            this.render();
        }
    }

    handleReset(e: JQuery.UIEventBase) {
        e.preventDefault();
        e.stopPropagation();

        this.delegateEvents();
    }

    handleCreateActionPacket(e: JQuery.UIEventBase) {
        var command = $(e.currentTarget).attr('data-command');
        var sensorId = Number($(e.currentTarget).attr('data-sensor-id'));
        var fieldValue = Number($(e.currentTarget).attr('data-value'));

        var sensorAndCOmmand: any = {
            sensor_id: sensorId,
            name: command + ' Packet'
        };
        var sensorActionPacket: any = this.actionPacketCollection.findWhere(sensorAndCOmmand);
        console.log('sap', sensorActionPacket);
        if (sensorActionPacket) {
            var commandName: any = {name: command};
            var partial: any = _.find(sensorActionPacket.get('partials'), commandName);

            var pkt = new this.actionPacketCollection.model({
                fields: [{name: command, value: fieldValue}],
                partialId: partial.id,
                createdSeconds: Math.floor((new Date()).getTime() / 1000),
                validSeconds: 3600,
                uniqueName: command
            });

            this.actionPacketCollection.add(pkt);
            pkt.save();
        }
    }

    render() {
        var internalSensors;
        var internalSensorsConf = this.options.sensorConfigCollection.findWhere({type: "INTERNAL_SENSORS"});
        if (internalSensorsConf) {
            internalSensors = internalSensorsConf.get('value') >= 1;
        } else {
            internalSensors = false;
        }

        this.$el.html(this.template({
            moduleModel: this.model,
            sensorsExpanded: this.sensorsExpanded,
            channelsChecked: this.channelsChecked,
            internalSensors: internalSensors,
            permissionCollection: this.options.permissionCollection,
            installId: this.options.currentInstallId,
            filters: this.currentFilter,
            sensorStatus: new SensorStatus({
                sensorConfigCollection: this.options.sensorConfigCollection,
                moduleModel: this.model
            })
        }));

        // Make checkboxes a toggle switch
        (<any> this.$('[data-toggle="toggle"]')).bootstrapToggle();

        // Activate tooltips
        (<any> $('[data-toggle="tooltip"]')).tooltip();

        (<any> $('[data-toggle="tooltip"] .causes')).tooltip({
            placement:'auto top',
        });


        // Activate Popovers
        (<any> $('[data-toggle="popover"]')).popover({
            placement: 'auto left',
            html: true,
            content: function () {
                var $this = $(<string> this);
                var values;
                var labels;
                var command;
                var sensor_id = $this.attr('data-sensor-id');
                var connector = $this.attr('data-connector');
                if ($this.attr('data-sdcard')) {
                    values = [1, 2];
                    labels = ['Reset', 'Clear'];
                    command = "Reset SD";
                } else {
                    command = "Reset";
                    values = [1, 2];
                    labels = ['Soft Reset', 'Hard Reset'];
                }
                return '' +
                    '<a href="#" tabindex="999" class="btn btn-xs btn-default reset-button in-popover create-ap" data-sensor-id="' + sensor_id + '" data-command="' + command + '" data-value="' + values[0] + '">' + labels[0] + '</a>' +
                    '<a href="#" tabindex="999" class="btn btn-xs btn-default reset-button create-ap" data-sensor-id="' + sensor_id + '" data-command="' + command + '" data-value="' + values[1] + '">' + labels[1] + '</a>';
            }
        });

        // Re-delegate events
        this.delegateEvents();

        return this;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/status/SidePanelView.ts